import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
	selector: 'ifective-browser-not-supported',
	templateUrl: './browser-not-supported.component.html',
	styleUrls: ['./browser-not-supported.component.scss']
})
export class BrowserNotSupportedComponent implements OnInit {

	constructor(
		private renderer: Renderer2
	) { }

	ngOnInit() {

	}

	ngOnDestroy(): void {

	}
}
